import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import TenantUserCreateForm from '@src/features/tenant/tenant-user/TenantUserCreateForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function TenantUserCreate() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <TenantUserCreateForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default TenantUserCreate;
